import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useBusinessStatus } from "@/context/BusinessStatusContext";
import { money } from "@/lib/api";

export default function StickyOrderBar() {
  const { count, subtotal, setOpen } = useCart();
  const { status: bizStatus } = useBusinessStatus();
  const orderLabel = bizStatus?.status === "closed" ? "Pre-Order" : "Order Now";
  const navigate = useNavigate();
  const { pathname } = useLocation();
  if (pathname === "/admin") return null;

  return (
    <div data-testid="sticky-bottom-order-bar" className="md:hidden fixed bottom-0 left-0 right-0 z-30 px-3 pt-3 pb-safe bg-[#0A2818]/95 backdrop-blur-xl border-t border-amber-500/30 shadow-[0_-8px_30px_rgba(0,0,0,0.5)]">
      {count > 0 ? (
        <button
          data-testid="sticky-bottom-order-bar-button"
          onClick={() => setOpen(true)}
          className="w-full flex items-center justify-between px-5 py-3.5 rounded-full bg-amber-400 text-[#0A2818] font-display font-black uppercase tracking-wide active:scale-95 transition-transform"
        >
          <span className="flex items-center gap-2"><ShoppingBag className="w-5 h-5" /> View Cart · {count}</span>
          <span>{money(subtotal)}</span>
        </button>
      ) : (
        <div className="grid grid-cols-2 gap-2">
          <button
            data-testid="sticky-bottom-order-bar-button"
            onClick={() => navigate("/menu")}
            className="px-4 py-3.5 rounded-full bg-amber-400 text-[#0A2818] font-display font-black uppercase tracking-wide text-sm active:scale-95 transition-transform"
          >
            {orderLabel}
          </button>
          <button
            data-testid="sticky-bottom-catering-button"
            onClick={() => navigate("/catering")}
            className="px-4 py-3.5 rounded-full bg-emerald-800 text-amber-300 border border-amber-500/40 font-display font-black uppercase tracking-wide text-sm active:scale-95 transition-transform"
          >
            Catering
          </button>
        </div>
      )}
    </div>
  );
}
